/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlProductTrialLinkRequest
 */
export interface ControlProductTrialLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlProductTrialLinkRequest
     */
    product_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProductTrialLinkRequest
     */
    success_url: string;
    /**
     * 
     * @type {number}
     * @memberof ControlProductTrialLinkRequest
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlProductTrialLinkRequest
     */
    adjust_quantity?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlProductTrialLinkRequest
     */
    locale?: string;
}

/**
 * Check if a given object implements the ControlProductTrialLinkRequest interface.
 */
export function instanceOfControlProductTrialLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success_url" in value;

    return isInstance;
}

export function ControlProductTrialLinkRequestFromJSON(json: any): ControlProductTrialLinkRequest {
    return ControlProductTrialLinkRequestFromJSONTyped(json, false);
}

export function ControlProductTrialLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlProductTrialLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'success_url': json['success_url'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'adjust_quantity': !exists(json, 'adjust_quantity') ? undefined : json['adjust_quantity'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
    };
}

export function ControlProductTrialLinkRequestToJSON(value?: ControlProductTrialLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_id': value.product_id,
        'success_url': value.success_url,
        'quantity': value.quantity,
        'adjust_quantity': value.adjust_quantity,
        'locale': value.locale,
    };
}

